// Side-effect module. Imported FIRST in main.tsx so that registerLicense
// runs before any other Syncfusion module is loaded into the bundle graph.
// Syncfusion components check the registered license in their constructor
// — if registerLicense happens after a component is already instantiated,
// the trial banner shows even when the key is valid.

import { registerLicense } from "@syncfusion/ej2-base";

const key = import.meta.env.VITE_SYNCFUSION_LICENSE_KEY;
if (key && key.length > 0) {
    registerLicense(key);
}
